import { FunctionComponent } from "react";

export interface Props {
  className?: string;
  fill?: string;
  width?: number;
  height?: number;
  viewBox?: string;
}

const UserIcon: FunctionComponent<Props> = ({
  className = "",
  fill = "",
  width = 18,
  height = 24,
  viewBox = "0 0 18 24",
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      tabIndex={-1}
      aria-hidden="true"
      viewBox={viewBox}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.063 4.872c0 2.69-2.267 4.872-5.063 4.872S3.937 7.563 3.937 4.872C3.937 2.182 6.204 0 9 0s5.063 2.181 5.063 4.872ZM2.778 13.598c1.65-1.588 3.888-2.48 6.222-2.48 2.334 0 4.572.892 6.223 2.48 1.65 1.588 2.577 3.742 2.577 5.988V23.2H.2v-3.614c0-2.246.927-4.4 2.578-5.988Z"
        fill={fill}
      />
    </svg>
  );
};

export default UserIcon;
